/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const Poll = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path
        d="m5.5 2v5c0 .08360857.00292264.16680385.00873363.24948783.10632739 1.49894776 1.16262206 2.76622947 2.6158956 3.14027617.22094087.0568663.37537077.2560768.37537077.4842185v3.1260175c0 .2761424-.22385763.5-.5.5h-2c-.27614237 0-.5.2238576-.5.5v1.5h7v-1.5c0-.2761424-.2238576-.5-.5-.5h-2c-.27614237 0-.5-.2238576-.5-.5v-3.1260175c0-.2281417.1544299-.4273522.37537077-.4842185 1.45327353-.3740467 2.50956823-1.64132841 2.61581263-3.14028962.005894-.08267053.0088166-.16586581.0088166-.24947438v-5-.5h-7zm-1 4.69106781v-4.19106781h-1.98095892c.12323111 1.61317185.83892226 3.09624607 1.98095892 4.19106781zm0-5.19106781v-.5c0-.27614237.22385763-.5.5-.5h8c.2761424 0 .5.22385763.5.5v.5h2.5c.2761424 0 .5.22385763.5.5 0 2.4517778-1.1858323 4.7035257-3.1360224 6.10033477-.3654608 1.45116114-1.4383084 2.64053693-2.8639776 3.14359063v2.2560746h1.5c.8284271 0 1.5.6715729 1.5 1.5v2c0 .2761424-.2238576.5-.5.5h-8c-.27614237 0-.5-.2238576-.5-.5v-2c0-.8284271.67157288-1.5 1.5-1.5h1.5v-2.2560746c-1.42566921-.5030537-2.49851679-1.69242949-2.86397762-3.14359063-1.95019006-1.39680907-3.13602238-3.64855697-3.13602238-6.10033477 0-.27614237.22385763-.5.5-.5zm9 1v4.19106781c1.1420367-1.09482174 1.8577278-2.57789596 1.9809589-4.19106781z"
        fill="#3d3d36"
      />
    </BaseSvgIcon>
  )
}

export default Poll
